import './winmock12/style';
import FormStructure from './winmock12/form_structure';

export default FormStructure;